import { render, staticRenderFns } from "./trend.vue?vue&type=template&id=1debe28d&"
import script from "./trend.vue?vue&type=script&lang=ts&"
export * from "./trend.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports